import type { TenantAttribute as PrismaTenantAttribute } from '@generated/prisma/enums';

// Re-export Prisma `TenantAttribute` type
export type TenantAttribute = PrismaTenantAttribute;

export const TenantAttribute: { [K in PrismaTenantAttribute]: K } = {
  ALPHA_CUSTOMER: 'ALPHA_CUSTOMER',
  BETA_CUSTOMER: 'BETA_CUSTOMER',
  EXPLORE_EVENTS: 'EXPLORE_EVENTS',
  IMU_CUSTOMER: 'IMU_CUSTOMER',
};

export const isTenantAttribute = (input: string): input is TenantAttribute => {
  return Object.values(TenantAttribute).includes(input as TenantAttribute);
};
